import { Fragment } from "react";
import { ReplacementCartItem } from "features/reducers/replacementOrder/cart.ts";
import ReplacementReasonsHeaderContainer from "components/Replacements/components/ReplacementReasonsHeaderContainer/ReplacementReasonsHeaderContainer.tsx";
import SelectReplacementReason from "components/Replacements/SelectReplacementReason.tsx";
import { Divider } from "@mui/material";
import { ReplacementReasonBoxContainer } from "components/Replacements/ReplacementReasonBox/ReplacementReasonBox.styles.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

interface ReplacementReasonBoxProps {
	item: ReplacementCartItem;
	itemIndex: number;
}

export const ReplacementReasonBox = ({ item, itemIndex }: ReplacementReasonBoxProps) => {
	const { isReplacementsReasonPage } = useUserLocation();
	return (
		<ReplacementReasonBoxContainer>
			<ReplacementReasonsHeaderContainer item={item} />
			{item.wholeCabinetQuantity > 0 && (
				<div data-testid="replacementReason-selectReplacementReasonComponent">
					<SelectReplacementReason
						item={item}
						fieldPrefix={`items.${itemIndex}.cabinet`}
						uploadedImages={item.cabinetFileUploads?.map((file) => file.name)}
						reasonReview={
							isReplacementsReasonPage
								? undefined
								: `${item.cabinetReplacementReason} - ${item.cabinetReplacementProblem}`
						}
						comment={isReplacementsReasonPage ? undefined : item.comment}
					/>
				</div>
			)}
			{item.replaceableParts
				?.filter((part) => part.partQuantity > 0)
				.map((part, partIndex, visibleParts) => (
					<Fragment key={part.id}>
						<SelectReplacementReason
							part={part}
							item={item}
							fieldPrefix={`items.${itemIndex}.parts.${partIndex}`}
							uploadedImages={part.partFileUploads?.map((file) => file.name)}
							reasonReview={
								isReplacementsReasonPage
									? undefined
									: `${part.partReplacementReason} - ${part.partReplacementProblem}`
							}
							comment={isReplacementsReasonPage ? undefined : part.comment}
						/>
						{partIndex + 1 !== visibleParts.length && <Divider />}
					</Fragment>
				))}
		</ReplacementReasonBoxContainer>
	);
};
